// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8792 ? "main" : chunkId) + "." + {"3394":"02819c940ae1f6707291","8792":"41caffdebe24077270e7"}[chunkId] + ".css";
};